import { Injectable } from "@angular/core";
import * as Stripe from '@stripe/stripe-js';
import { Constant } from "../constant";

@Injectable({
  providedIn: 'root',
})
export class StripeService {
  
  protected instance: Stripe.Stripe | null = null;

  constructor(private readonly constant: Constant) {}

  public async confirmOxxoPayment(clientSecret: string): Promise<Stripe.PaymentIntentResult | undefined> {
    if (this.instance == null) {
      this.instance = await Stripe.loadStripe(this.constant.stripeKey);
    }

    return this.instance?.confirmOxxoPayment(clientSecret, {
      return_url: location.href,
      payment_method: {
        billing_details: {
          name: 'juan daniel',
          email: 'asdasd@asdd.com',
        },
      },
    });
  }

  public async verifyNextActions(clientSecret: string) {
    if (this.instance == null) {
      this.instance = await Stripe.loadStripe(this.constant.stripeKey);
    }

    return this.instance?.confirmPayment({
      clientSecret,
      redirect: 'if_required'
    });
  }
}